var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('CourseHeader',{attrs:{"imgSrc":require(`@/assets/cocarde_grise.png`),"title":"Parcours Maître d'apprentissage","subtitle":"Page en cours de construction..."}}),_c('DocumentDisplayer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }